import { i18n } from '@easydata/core';
function addOldEasyQueryUIMapper() {
    i18n.addMapper(function (info) {
        if (!info && !info.texts)
            return;
        for (var prop in info.texts) {
            switch (prop) {
                case 'PredicateTitle':
                    info.texts['ConditionGroupTitle'] = info.texts[prop];
                    break;
                case 'RootPredicateTitle':
                    info.texts['RootConditionGroupTitle'] = info.texts[prop];
                    break;
                case 'ErrIncorrectPredicateTitleFormat':
                    info.texts['ErrIncorrectGroupTitleFormat'] = info.texts[prop];
                    break;
                case 'ButtonAddPredicate':
                    info.texts['ButtonAddGroup'] = info.texts[prop];
                    break;
                case 'ButtonDelete':
                    info.texts['CmdDelete'] = info.texts[prop];
                    break;
                case 'ButtonClear':
                    info.texts['CmdClear'] = info.texts[prop];
                    break;
                case 'ButtonEnable':
                    info.texts['CmdToggleEnable'] = info.texts[prop];
                    break;
                case 'ButtonAddCondition':
                    info.texts['CmdAddCondition'] = info.texts[prop];
                    break;
                case 'ButtonAddGroup':
                    info.texts['CmdAddCondGroup'] = info.texts[prop];
                    break;
                default:
                    //do nothing
                    break;
            }
        }
    });
}
function addEasyQueryUITexts() {
    i18n.updateDefaultTexts({
        AltMenuAttribute: 'Attribute',
        AltMenuConstantExpression: 'Constant expression',
        ButtonApply: 'Apply',
        ButtonCancel: 'Cancel',
        ButtonClose: 'Close',
        ButtonNext: 'Next',
        ButtonPrev: 'Prev',
        ButtonNow: 'Now',
        ButtonOK: 'OK',
        MenuEnable: 'Enabled',
        MenuParameterization: 'Parameterized',
        MenuJoinCond: 'Use in JOIN',
        CmdClear: 'Clear',
        CmdDelete: 'Delete',
        CmdToggleEnable: 'Toggle enable',
        CmdAddCondition: 'Add condition',
        CmdAddCondGroup: 'Add group of conditions',
        ButtonSelectAll: 'Select all',
        ButtonDeselectAll: 'Clear selection',
        ButtonAddColumns: 'Add column(s)',
        ButtonAddConditions: 'Add condition(s)',
        CmdClickToAddCondition: '[Add new condition]',
        CmdDeleteRow: 'Delete this row',
        ErrIncorrectGroupTitleFormat: 'Incorrect condition group title format',
        ErrNotNumber: ' is not a number',
        ErrIncorrectInteger: 'Incorrect integer value',
        ErrIncorrectNumberList: 'Incorrect list format',
        False: 'False',
        LinkTypeAll: 'all',
        LinkTypeAny: 'any',
        LinkTypeNone: 'none',
        LinkTypeNotAll: 'not all',
        ConjAll: 'and',
        ConjAny: 'or',
        ConjNotAll: 'and',
        ConjNone: 'or',
        MsgApplySelection: '[Apply selection]',
        MsgAs: 'as',
        MsgEmptyList: '(empty list)',
        MsgEmptyListValue: '[select value]',
        MsgEmptyScalarValue: '[enter value]',
        MsgSubQueryValue: '[edit sub-query]',
        MsgEmptyAttrValue: '[select attribute]',
        MsgEmptyOperator: '[Unrecognized operator]',
        MsgEmptyCustomSql: '[enter SQL expression]',
        MsgCustomSql: '[Custom SQL]',
        MsgNoResult: 'No result',
        MsgResultCount: '{0} records found',
        MsgOf: 'of',
        ConditionGroupTitle: '{lt} of the following apply',
        RootConditionGroupTitle: 'Select records where {lt} of the following apply',
        StrAddConditions: 'Add conditions',
        SubQueryDialogTitle: 'Edit sub-query',
        SubQueryColumnTitle: 'Column:',
        SubQueryEmptyColumn: '[select column]',
        SubQueryQueryPanelCaption: 'Conditions',
        True: 'True',
        ButtonSorting: 'Sorting',
        ButtonToAggr: 'Change to aggregate column',
        ButtonToSimple: 'Change to simple column',
        ButtonFormat: 'Display format',
        CmdAscending: 'Ascending',
        CmdClickToAddColumn: '[Add new column]',
        CmdDeleteColumn: 'Delete column',
        CmdDeleteSorting: 'Delete sorting',
        CmdDescending: 'Descending',
        CmdGroupSort: 'Sorting',
        CmdGroupFormat: 'Display format',
        CmdNotSorted: 'Not sorted',
        ColTypeAggrFunc: 'Aggregate function',
        ColTypeCompound: 'Calculated',
        ColTypeGroup: 'Column type',
        ColTypeSimple: 'Simple column',
        HeaderExpression: 'Expression',
        HeaderSorting: 'Sorting',
        HeaderTitle: 'Title',
        SortHeaderColumn: 'Column',
        SortHeaderSorting: 'Sorting',
        StrAddColumns: 'Add columns',
        CustomExpression: 'Custom Expression',
        AddAllForEntityText: '[Add all attributes]',
        CmdMoveToStart: 'Move to start',
        CmdMoveRight: 'Move right',
        CmdMoveLeft: 'Move left',
        CmdMoveToEnd: 'Move to the end',
        CmdMoveUp: 'Move up',
        CmdMoveDown: 'Move down',
        ButtonMenu: 'Show menu',
        CmdToSimple: 'Not aggregated',
        CmdMoveToFirst: 'Move to the first',
        CmdMoveToPrev: 'Move to the previous',
        CmdMoveToNext: 'Move to the next',
        CmdMoveToLast: 'Move to the last',
        CmdHiddenColumn: 'Hidden',
        RowButtonTitle: 'Click to see the available options',
        EntityToggle: 'Toggle entity',
        //FilterBar
        StrNoFilterDefined: 'No filter defined',
        StrNoFilterClickToAdd: 'No filter defined. Click to add a new condition',
        //Time picker
        HintHours: 'Hours',
        HintMinutes: 'Minutes',
        //advanced search view texts
        RemoveQueryTitle: 'Confirmation',
        RemoveQueryContent: 'Remove query [{queryName}]?',
        NewQueryTitle: 'New query',
        NewQueryContent: 'New query name: ',
        NewQueryDefName: 'New query',
        SaveQueryTitle: 'Save query',
        SaveQueryContent: 'Query name: ',
        SaveQueryDefName: '{queryName} copy',
        QueryChangedTitle: 'Confirmation',
        QueryChangedContent: 'The query was changed. Do you want to save it first?',
        UpdateQuerySelector: '[click here to load the query]',
        FileNameLabel: 'File name: ',
        SaveQueryToFileDlgTitle: 'Save query to file',
        //report view texts
        NewReportDefName: 'New report',
        NewReportDlgTitle: 'New report',
        SaveReportDlgTitle: 'Save report',
        SaveReportDlgLabel: 'Report name:',
        ReportDescLabel: 'Description: ',
        RemoveReportDlgTitle: 'Remove report',
        RemoveReportContent: 'Are you sure you want to remove \'{reportName}\'?',
        //facets
        Facets: {
            TotalRecordsLabel: 'Total records:',
            AddMenuItems: {
                Chart: 'Chart',
                Pivot: 'Pivot table',
                DataTable: 'Data table'
            },
            LoadDataDlgTitle: 'Downloading data',
            LoadDataDlgContent: 'Records loaded: {loadedRecs}/{totalRecs}',
            RefreshBtnTitle: 'Refresh',
            ExportBtnTitle: 'Export',
            MaximizeBtnTitle: 'Maximize',
            RestoreBtnTitle: 'Restore Down',
            RemoveFacetDlgTitle: 'Remove facet',
            RemoveFacetDlgContent: "Are you sure, that you want to delete {facetTitle} tab?",
            DefaultDlgTitle: 'Setup facet',
            DefaultFacetTitle: '',
            NewFacetTitle: 'New Facet',
            TabNameLabel: 'Tab name',
            ErrQueryChanged: 'FAILED TO DISPLAY. QUERY WAS CHANGED',
            ErrNotEnoughData: "We can't display the graph because not all data for this query is loaded. \n        The total number of records: {totalRecs}, currently loaded: {cachedRecs}. \n        You can [download the result]. Please note: this may take some time and consume a lot of memory.",
            ErrTooMuchData: 'Too much data. The grid is not able to display it',
            Chart: {
                FacetTitle: 'Chart',
                DlgTitle: 'Chart settings',
                DataColumnSelectorLabel: 'Data column',
                LabelColumnSelectorLabel: 'Label column',
                ChartTypeSelectorLabel: 'Chart type',
                ShowLegendLabel: 'Show legend (if available)'
            },
            Pivot: {
                FacetTitle: 'Pivot table',
                DlgTitle: 'Pivot settings',
                SwapBtnTitle: 'Swap column and row fields',
                ColumnFieldSelectorLabel: 'Column field',
                RowFieldSelectorLabel: 'Row field',
                CellDataSelectorLabel: 'Cell data',
                TotalsRowLabel: 'Totals row',
                TotalsColLabel: 'Totals column',
                TotalGridLabel: 'Total'
            },
            DataTable: {
                FacetTitle: 'Result table',
                DlgTitle: 'Table facet settings'
            }
        },
        TotalsDlgLabel: 'Totals',
        GrandTotalsLabel: 'Grand totals',
        TotalsDlgTitle: 'Select totals',
        //formats
        ExportDlgTitle: 'Export result',
        ExportDlgFmtLabel: 'Format',
        'csv': 'CSV',
        'excel': 'Excel',
        'pdf': 'PDF',
        'excel-html': 'HTML (Excel-compatible)',
        // Aggregation settings
        AggrSettings: {
            GroupBtn: 'Group selected column(s)',
            UngroupBtn: 'Ungroup columns',
            AggrBtn: 'Aggregate selected column',
            UnaggrBtn: 'Remove column aggregation',
            GrandTotalsLabel: 'Show grand totals',
            GroupCountsLabel: 'Show record count for groups',
            AggrDialogTitle: 'Aggregation/grouping',
            EnableAggrLabel: 'Enable aggregation',
            SelectedError: 'Complete the action with selected column(s)',
            NoGroupsOrAggrError: 'Add at least one group or aggregation',
            NoGroupsOrGrandError: 'Add at least one group, or enable grand totals',
            NoAggrOrCountError: 'Add at least one aggregation, or enable records count',
            NoGroupsLabel: 'No groups',
            NoAggrsLabel: 'No aggregations',
            EmptySettingsLabel: '[ Click to setup ]'
        },
        ChartType: {
            Area: 'Area chart',
            Bar: 'Bar chart',
            Column: 'Column chart',
            Combo: 'Combo chart',
            Doughnut: 'Doughnut chart',
            Polar: 'Polar chart',
            Radar: 'Radar chart',
            Histogram: 'Histogram chart',
            Line: 'Line chart',
            SteppedLine: 'Stepped line chart',
            Pie: 'Pie chart'
        }
    });
}
addOldEasyQueryUIMapper();
addEasyQueryUITexts();
//# sourceMappingURL=text_resources.js.map